// Class: swf.exporters.swflite.timeline.FrameObject

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;

// Constructor

var FrameObject = function() {
}

// Meta

FrameObject.__name__ = "swf.exporters.swflite.timeline.FrameObject";
FrameObject.__isInterface__ = false;
FrameObject.prototype = {
	
};
FrameObject.prototype.__class__ = FrameObject.prototype.constructor = $hxClasses["swf.exporters.swflite.timeline.FrameObject"] = FrameObject;

// Init



// Statics




// Export

exports.default = FrameObject;